import { render } from "./App.vue?vue&type=template&id=02f0d9e2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=02f0d9e2&lang=css"

import exportComponent from "/Users/aryan/Task-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__